import { render, staticRenderFns } from "./PageAssetOverview.vue?vue&type=template&id=2055fb28&scoped=true"
import script from "./PageAssetOverview.vue?vue&type=script&lang=js"
export * from "./PageAssetOverview.vue?vue&type=script&lang=js"
import style0 from "./PageAssetOverview.vue?vue&type=style&index=0&id=2055fb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2055fb28",
  null
  
)

export default component.exports